import useBackend from '@shared/hooks/useBackend'

import config from '@shared/config'

function systemNotification() {
  const { doGet, setup } = useBackend()

  setup('/portalconfiguration', config.microserviceBaseUrl)

  async function getSystemNotifications(
    {
      language,
      channel = 'DVP'
    }
  ) {
    const response = await doGet({
      url: '/public/system-notifications', params: {
        lang: language.toLowerCase(),
        channel,
      }
    })

    return response
  }

  return {
    getSystemNotifications
  }
}

export default systemNotification()
